import http from "../http-common";

const getAll = () => {
    return http.get("/outputs");
};

const get = (id) => {
    return http.get(`/outputs/${id}`);
};


const create = data => {
    return http.post("/outputs", data);
};

const update = (id, data) => {
    return http.put(`/outputs/${id}`, data);
};

const remove = id => {
    return http.delete(`/outputs/${id}`);
};

const removeAll = () => {
    return http.delete(`/outputs`);
};

const findByTitle = title => {
    return http.get(`/outputs?title=${title}`);
};

const OutputsService = {
    getAll,
    get,
    create,
    update,
    remove,
    removeAll,
    findByTitle
};

export default OutputsService;
